import React, { Component } from 'react'

class Overview extends Component {
  render() {
    let background_image_path = process.env.PUBLIC_URL + '/assets/images/library.jpg'
    return (
      <section
        id="overview"
        className="overview"
        style={{
          backgroundImage: 'url(' + background_image_path + ')'
        }}
      >
        <div className="container">
          <h2 className="section-title">
            開催概要
          </h2>
          <div className="section-body">
            <div className="content">
              <h3 className="content__title">参加対象</h3>
              <p className="content__body">20{`${this.props.grad_year}`}年卒業見込みの方</p>
            </div>
            <div className="content">
              <h3 className="content__title">参加費用</h3>
              <p className="content__body">完全無料</p>
            </div>
            <div className="content">
              <h3 className="content__title">集合時間</h3>
              <p className="content__body">【東京開催】12時20分～受付開始</p>
            </div>
            <div className="content">
              <h3 className="content__title">開催場所</h3>
              <p className="content__body">
                【東京開催】
                <br/>
                〒160-0023
                <br/>
                東京都新宿区西新宿1-22-2
                <br/>
                新宿サンエービル地下1階or8階
              </p>
            </div>
            <div className="content">
              <h3 className="content__title">事前準備物</h3>
              <p className="content__body">
                筆記用具・大学指定の写真付き履歴書（志望動機のみ空白）
                <br/>
                ※コピーでもOKです
              </p>
            </div>
            <div className="content">
              <h3 className="content__title">服装</h3>
              <p className="content__body">スーツ着用（私服でも参加可能となっております）</p>
            </div>
            <div className="content">
              <h3 className="content__title">お問い合わせ先</h3>
              <p className="content__body">
                株式会社ネオキャリア　就職エージェントイベント運営事務局
                <br/>
                03-5908-8328 （イベント担当宛）
              </p>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default Overview